var _defs, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTodueMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "todue-mark",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "379.55 4.55 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 { fill: #f24c4c; }\n      .st2 { fill: #37b758; }\n      .st3 { fill: #f2b01c; }\n      .st4 { fill: #4ca7f2; }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M391.09,16.05h11.46V4.55h-14.38c-4.76,0-8.62,3.86-8.62,8.62v14.38h11.54v-11.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M402.55,4.55v11.5h11.54v11.5h11.46v-14.38c0-4.76-3.86-8.62-8.62-8.62h-14.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M391.09,39.05v-11.5h-11.54v14.38c0,4.76,3.86,8.62,8.62,8.62h14.38v-11.5h-11.46Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.09,39.05h-11.54v11.5h14.38c4.76,0,8.62-3.86,8.62-8.62v-14.38h-11.46v11.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodueMark);
export default __webpack_public_path__ + "static/media/todue-mark.ffe18d21c594b19ac36b920c437801eb.svg";
export { ForwardRef as ReactComponent };